import { Modal } from 'react-bootstrap-v5';
import { OrderViewModel } from '../../orders/models/OrderViewModel';
import { Formik, FormikHelpers, Form } from 'formik';
import { packedSchemaValidation } from '../utils/packedSchemaValidation';
import { CustomInput } from '../../../components/CustomInput';
import { useIntl } from 'react-intl';
import { ActionsComponent } from '../../../components/ActionsComponent';

interface Props {
  packOrder: (
    id: number,
    trackingNumber: string,
    currentStatus: string
  ) => void;
  show: boolean;
  order: OrderViewModel;
  onHide: () => void;
}
interface PackOrderModel {
  trackingNumber: string;
}

export function PackOrderModal({ packOrder, show, order, onHide }: Props) {
  const intl = useIntl();
  const save = (
    values: PackOrderModel,
    actions: FormikHelpers<PackOrderModel>
  ) => {
    packOrder(order.id, values.trackingNumber, order.status);
  };
  return (
    <Modal show={show} onHide={onHide} backdrop='static' keyboard={false}>
      <Formik
        enableReinitialize
        initialValues={{ trackingNumber: '' }}
        validationSchema={packedSchemaValidation(intl)}
        onSubmit={(values, actions) => {
          save(values, actions);
          actions.setSubmitting(false);
        }}
      >
        <Form>
          <Modal.Body className='mt-1 px-6 py-6 position-relative z-index-1'>
            <div className='d-flex align-items-center'>
              <i className={`las la-exclamation-circle fs-5x text-warning`}></i>
              <div className='flex-grow-3 ms-4'>
                <div className='fw-bold text-gray-700 fs-6'>
                  Are you sure you want to change the status of the order{' '}
                  <span className='fw-bolder'>#{order.id}</span> from{' '}
                  <span className='fw-bolder'>{order.status}</span> to{' '}
                  <span className='fw-bolder'>Pack</span>?
                </div>
              </div>
            </div>
            <div className='row pt-5'>
              <div className='col-12'>
                <CustomInput
                  name='trackingNumber'
                  type='text'
                  label='Tracking Number'
                  autoFocus
                  isRequired={true}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className='border-0'>
            <ActionsComponent
              labelSubmit='Yes'
              labelDiscard='No'
              showCancelButton={true}
              onCancel={onHide}
            />
          </Modal.Footer>
        </Form>
      </Formik>
    </Modal>
  );
}
